"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseFilterSchema = void 0;
const case_enums_1 = require("../enums/case-enums");
const zod_1 = require("zod");
exports.CaseFilterSchema = zod_1.z
    .object({
    commerceState: zod_1.z.nativeEnum(case_enums_1.CommercialisationState).optional(),
    ipState: zod_1.z.nativeEnum(case_enums_1.IPProtectionState).optional(),
})
    .strip();
